export default __webpack_public_path__ + "static/media/sec-11.908718d1.jpg";